export default {
  modal: false,
  modalMini: false,
  currentUserCall: {
    phone: null,
    name: null,
    customerId: null,
  },
  tmpCurrentCallUser: null,
  vuexCallStatus: {
    onCall: false,
    incoming: false,
  },
  onModalCloseCallback: null,
  callioResultOptions: [],
}
